module.exports = __webpack_public_path__ + "static/linkedlist-2.1-76f0026d6b6ae9e99d3d5e09d9201675.png";